var parseVersion = function(str) {
	// see webpack/lib/util/semver.js for original code
	var p=function(p){return p.split(".").map((function(p){return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = function(a, b) {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = function(range) {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = function(range, version) {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = function(scopeName, key) {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = function(scope, key) {
	var versions = scope[key];
	var key = Object.keys(versions).reduce(function(a, b) {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = function(scope, key) {
	var versions = scope[key];
	return Object.keys(versions).reduce(function(a, b) {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = function(scope, key, version, requiredVersion) {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = function(scope, scopeName, key, requiredVersion) {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = function(scope, scopeName, key, requiredVersion) {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) typeof console !== "undefined" && console.warn && console.warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = function(scope, scopeName, key, requiredVersion) {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = function(scope, key, requiredVersion) {
	var versions = scope[key];
	var key = Object.keys(versions).reduce(function(a, b) {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = function(scope, scopeName, key, requiredVersion) {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map(function(key) {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = function(scope, scopeName, key, requiredVersion) {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warnInvalidVersion = function(scope, scopeName, key, requiredVersion) {
	typeof console !== "undefined" && console.warn && console.warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = function(entry) {
	entry.loaded = 1;
	return entry.get()
};
var init = function(fn) { return function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
}; };

var load = /*#__PURE__*/ init(function(scopeName, scope, key) {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init(function(scopeName, scope, key, fallback) {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init(function(scopeName, scope, key) {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init(function(scopeName, scope, key, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	92950: function() { return loadSingletonVersionCheckFallback("default", "react", [1,17,0,2], function() { return __webpack_require__.e(8587).then(function() { return function() { return __webpack_require__(8587); }; }); }); },
	12181: function() { return loadSingletonVersionCheckFallback("default", "react-dom", [1,17,0,2], function() { return __webpack_require__.e(6839).then(function() { return function() { return __webpack_require__(36839); }; }); }); },
	5691: function() { return loadStrictVersionCheckFallback("default", "clsx", [1,1,2,1], function() { return __webpack_require__.e(5736).then(function() { return function() { return __webpack_require__(25736); }; }); }); },
	55191: function() { return loadStrictVersionCheckFallback("default", "@emotion/react", [1,11,7,0], function() { return Promise.all([__webpack_require__.e(2070), __webpack_require__.e(6316)]).then(function() { return function() { return __webpack_require__(86316); }; }); }); },
	24286: function() { return loadStrictVersionCheckFallback("default", "clsx", [1,1,2,1], function() { return __webpack_require__.e(8748).then(function() { return function() { return __webpack_require__(78748); }; }); }); },
	70551: function() { return loadStrictVersionCheckFallback("default", "clsx", [1,1,2,1], function() { return __webpack_require__.e(8985).then(function() { return function() { return __webpack_require__(68985); }; }); }); },
	88149: function() { return loadStrictVersionCheckFallback("default", "@emotion/styled", [1,11,6,0], function() { return __webpack_require__.e(7025).then(function() { return function() { return __webpack_require__(27025); }; }); }); },
	56289: function() { return loadStrictVersionCheckFallback("default", "three", [4,0,135,0], function() { return __webpack_require__.e(8874).then(function() { return function() { return __webpack_require__(38874); }; }); }); },
	47287: function() { return loadStrictVersionCheckFallback("default", "@mui/material", [1,5,2,3], function() { return Promise.all([__webpack_require__.e(6308), __webpack_require__.e(8745), __webpack_require__.e(8094), __webpack_require__.e(9704), __webpack_require__.e(1411), __webpack_require__.e(3559), __webpack_require__.e(2066)]).then(function() { return function() { return __webpack_require__(3559); }; }); }); },
	18805: function() { return loadStrictVersionCheckFallback("default", "@mui/x-data-grid", [1,5,3,0], function() { return Promise.all([__webpack_require__.e(6308), __webpack_require__.e(8745), __webpack_require__.e(4224), __webpack_require__.e(5596), __webpack_require__.e(2066)]).then(function() { return function() { return __webpack_require__(34703); }; }); }); },
	26663: function() { return loadStrictVersionCheckFallback("default", "three-mesh-bvh", [2,0,5,11], function() { return __webpack_require__.e(797).then(function() { return function() { return __webpack_require__(60797); }; }); }); },
	78041: function() { return loadStrictVersionCheckFallback("default", "web-ifc", [4,0,0,35], function() { return Promise.all([__webpack_require__.e(1189), __webpack_require__.e(5671)]).then(function() { return function() { return __webpack_require__(41189); }; }); }); },
	63437: function() { return loadStrictVersionCheckFallback("default", "react-window", [1,1,8,7], function() { return __webpack_require__.e(7059).then(function() { return function() { return __webpack_require__(77059); }; }); }); },
	76951: function() { return loadStrictVersionCheckFallback("default", "history", [1,4,10,1], function() { return __webpack_require__.e(1198).then(function() { return function() { return __webpack_require__(93848); }; }); }); },
	10306: function() { return loadStrictVersionCheckFallback("default", "@mui/x-data-grid-generator", [1,5,4,0], function() { return Promise.all([__webpack_require__.e(6308), __webpack_require__.e(8094), __webpack_require__.e(7383), __webpack_require__.e(2066), __webpack_require__.e(9442)]).then(function() { return function() { return __webpack_require__(87383); }; }); }); },
	11353: function() { return loadStrictVersionCheckFallback("default", "three-dxf", [1,1,3,1], function() { return __webpack_require__.e(4238).then(function() { return function() { return __webpack_require__(14238); }; }); }); },
	12502: function() { return loadStrictVersionCheckFallback("default", "dexie", [1,3,2,0], function() { return __webpack_require__.e(4690).then(function() { return function() { return __webpack_require__(4690); }; }); }); },
	12879: function() { return loadStrictVersionCheckFallback("default", "web-ifc-viewer", [4,1,0,210], function() { return __webpack_require__.e(5399).then(function() { return function() { return __webpack_require__(25399); }; }); }); },
	15462: function() { return loadStrictVersionCheckFallback("default", "react-simple-oauth2-login", [2,0,5,3], function() { return __webpack_require__.e(570).then(function() { return function() { return __webpack_require__(20570); }; }); }); },
	15603: function() { return loadStrictVersionCheckFallback("default", "react-dropbox-chooser", [3,0,0,5], function() { return __webpack_require__.e(4246).then(function() { return function() { return __webpack_require__(15385); }; }); }); },
	17433: function() { return loadStrictVersionCheckFallback("default", "react-dropzone", [1,11,3,4], function() { return __webpack_require__.e(6580).then(function() { return function() { return __webpack_require__(96580); }; }); }); },
	20125: function() { return loadStrictVersionCheckFallback("default", "jspdf", [1,2,5,1], function() { return __webpack_require__.e(3007).then(function() { return function() { return __webpack_require__(33007); }; }); }); },
	22046: function() { return loadStrictVersionCheckFallback("default", "dxf-parser", [1,1,1,2], function() { return __webpack_require__.e(6719).then(function() { return function() { return __webpack_require__(86719); }; }); }); },
	24526: function() { return loadStrictVersionCheckFallback("default", "react-rnd", [1,10,3,3], function() { return __webpack_require__.e(5477).then(function() { return function() { return __webpack_require__(25477); }; }); }); },
	26570: function() { return loadStrictVersionCheckFallback("default", "react-vtree", [1,3,0,0,,"beta",3], function() { return __webpack_require__.e(221).then(function() { return function() { return __webpack_require__(84360); }; }); }); },
	31082: function() { return loadStrictVersionCheckFallback("default", "@material-ui/styles", [1,4,11,5], function() { return __webpack_require__.e(5055).then(function() { return function() { return __webpack_require__(15055); }; }); }); },
	31734: function() { return loadStrictVersionCheckFallback("default", "dxf-writer", [1,1,17,1], function() { return __webpack_require__.e(5199).then(function() { return function() { return __webpack_require__(45199); }; }); }); },
	37735: function() { return loadSingletonVersionCheckFallback("default", "@reduxjs/toolkit", [1,2,2,6], function() { return __webpack_require__.e(8633).then(function() { return function() { return __webpack_require__(78633); }; }); }); },
	38956: function() { return loadStrictVersionCheckFallback("default", "react-helmet", [1,6,1,0], function() { return __webpack_require__.e(6921).then(function() { return function() { return __webpack_require__(56921); }; }); }); },
	45819: function() { return loadSingletonVersionCheckFallback("default", "react-router-dom", [1,5,1,2], function() { return __webpack_require__.e(8515).then(function() { return function() { return __webpack_require__(88515); }; }); }); },
	91592: function() { return loadStrictVersionCheckFallback("default", "tree-flatten", [1,1,0,0], function() { return __webpack_require__.e(2296).then(function() { return function() { return __webpack_require__(82296); }; }); }); },
	93916: function() { return loadStrictVersionCheckFallback("default", "react-virtualized-auto-sizer", [1,1,0,6], function() { return __webpack_require__.e(7487).then(function() { return function() { return __webpack_require__(43008); }; }); }); },
	95136: function() { return loadSingletonVersionCheckFallback("default", "react-redux", [4,7,2,8], function() { return __webpack_require__.e(2409).then(function() { return function() { return __webpack_require__(72409); }; }); }); },
	96703: function() { return loadStrictVersionCheckFallback("default", "@parametricos/bcf-js", [2,0,1,3], function() { return __webpack_require__.e(9791).then(function() { return function() { return __webpack_require__(29791); }; }); }); },
	96992: function() { return loadStrictVersionCheckFallback("default", "axios", [2,0,24,0], function() { return __webpack_require__.e(4301).then(function() { return function() { return __webpack_require__(4301); }; }); }); },
	72066: function() { return loadStrictVersionCheckFallback("default", "clsx", [1,1,2,1], function() { return __webpack_require__.e(7660).then(function() { return function() { return __webpack_require__(97660); }; }); }); },
	79442: function() { return loadStrictVersionCheckFallback("default", "@mui/x-data-grid-pro", [1,5,13,0], function() { return Promise.all([__webpack_require__.e(8745), __webpack_require__.e(4224), __webpack_require__.e(2204), __webpack_require__.e(7287), __webpack_require__.e(8805)]).then(function() { return function() { return __webpack_require__(41583); }; }); }); }
};
// no consumes in initial chunks
var chunkMapping = {
	"2066": [
		72066
	],
	"2132": [
		24286,
		70551,
		88149
	],
	"2181": [
		12181
	],
	"2950": [
		92950
	],
	"3437": [
		63437
	],
	"5191": [
		55191
	],
	"5691": [
		5691
	],
	"6289": [
		56289
	],
	"6951": [
		76951
	],
	"7287": [
		47287
	],
	"8627": [
		26663,
		78041
	],
	"8805": [
		18805
	],
	"9442": [
		79442
	],
	"9977": [
		10306,
		11353,
		12502,
		12879,
		15462,
		15603,
		17433,
		20125,
		22046,
		24526,
		26570,
		31082,
		31734,
		37735,
		38956,
		45819,
		91592,
		93916,
		95136,
		96703,
		96992
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = function(factory) {
				installedModules[id] = 0;
				__webpack_require__.m[id] = function(module) {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = function(error) {
				delete installedModules[id];
				__webpack_require__.m[id] = function(module) {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}